export default "__VITE_ASSET__DgdspwqO__"